import Button from "@ui/button";
import { Panel } from "@ui/panel";
import { getConsent, setConsent } from "@u/consent";
import { buildRoute } from "@u/routes";
import type { Language } from "@/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * Aviso de privacidad de las superficies públicas (landing, viewer `.360`,
 * `.tap`). Reemplaza al toast viejo, cuyo "Rechazar" no guardaba nada y volvía
 * a aparecer en cada carga.
 *
 * Aceptar y rechazar persisten igual; rechazar apaga la analítica anónima
 * (`utils/consent.ts`). No hay categorías porque no hay terceros que separar.
 */
export function ConsentBanner() {
  const { t, i18n } = useTranslation();
  const [decided, setDecided] = useState(() => getConsent() !== null);

  if (decided) return null;

  const choose = (value: "granted" | "denied") => {
    setConsent(value);
    setDecided(true);
  };

  const lang = (i18n.resolvedLanguage || i18n.language) as Language;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4 sm:inset-x-auto sm:left-4 sm:max-w-sm">
      <Panel surface="card" radius="xl" pad="md" className="shadow-lg">
        <p className="text-sm font-medium text-foreground">{t("privacy_title")}</p>
        <p className="mt-1 text-disclaimer">
          {t("privacy_desc")}{" "}
          <Link to={buildRoute.privacy(lang)} className="underline hover:text-foreground">
            {t("privacy_policy")}
          </Link>
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          <Button size="sm" onClick={() => choose("granted")}>
            {t("accept")}
          </Button>
          <Button design="outline" size="sm" onClick={() => choose("denied")}>
            {t("decline")}
          </Button>
        </div>
      </Panel>
    </div>
  );
}
